export default __webpack_public_path__ + "static/media/playlist_remove.7fd656a4.svg";